import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { FormProvider, UseFormReturn, FieldValues, SubmitHandler } from 'react-hook-form';

import { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import Button from '@ts-core/components/Button';

import ExerciseCoreInfoForm from '../ExerciseCoreInfoForm';
import ExerciseExplanationForm from '../ExerciseExplanationForm';

export interface BaseExerciseFormProps<TFieldValues extends FieldValues> {
  children: React.ReactNode;
  sx?: SxProps;

  onSubmit: SubmitHandler<TFieldValues>;
  useFormProps: UseFormReturn<TFieldValues>;

  submitting?: boolean;
}

const BaseExerciseForm = <TFieldValues extends FieldValues>(props: BaseExerciseFormProps<TFieldValues>) => {
  const { children, sx, useFormProps, onSubmit, submitting } = props;
  const intl = useIntl();
  const [selectedTab, setSelectedTab] = useState(0);

  function renderTab() {
    if (selectedTab === 1) {
      return <ExerciseExplanationForm />;
    }
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} lg={6}>
          <ExerciseCoreInfoForm />
        </Grid>
        <Grid item xs={12} lg={6}>
          {children}
        </Grid>
      </Grid>
    );
  }

  return (
    <Box width="100%" sx={sx}>
      <FormProvider {...useFormProps}>
        <form noValidate onSubmit={useFormProps.handleSubmit(onSubmit)}>
          <Box display="flex" mb={3}>
            <Tabs value={selectedTab} onChange={(e, value) => setSelectedTab(value)} textColor="secondary" indicatorColor="secondary">
              <Tab label={intl.formatMessage({ id: 'exercise.tab.exercise' })} sx={{ minWidth: 160 }} />
              <Tab label={intl.formatMessage({ id: 'exercise.tab.solution' })} sx={{ minWidth: 160 }} />
            </Tabs>
            <Box flexGrow={1} p={2} />
            <Button loading={submitting} type="submit">
              {intl.formatMessage({ id: 'button.save.title' })}
            </Button>
          </Box>
          {renderTab()}
        </form>
      </FormProvider>
    </Box>
  );
};

export default BaseExerciseForm;
